import { useEffect } from 'react'
import { Navigate, Route, Routes, useLocation } from 'react-router-dom'
import { useAuth } from './store/authStore.js'
import Layout from './components/layout/Layout.jsx'
import Login from './pages/Login.jsx'
import AcceptInvite from './pages/AcceptInvite.jsx'
import Dashboard from './pages/Dashboard.jsx'
import Profile from './pages/Profile.jsx'
import SurveyFlow from './pages/SurveyFlow.jsx'
import Result from './pages/Result.jsx'
import AdminZugaenge from './pages/AdminZugaenge.jsx'

export default function App() {
  const { user, loading, hydrate } = useAuth()
  const location = useLocation()
  useEffect(() => { hydrate() }, [hydrate])

  if (loading) {
    return (
      <div className="min-h-screen grid place-items-center text-ink-soft">
        Lade Mindnet Academy…
      </div>
    )
  }

  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/invite/:token" element={<AcceptInvite />} />
      <Route element={user ? <Layout /> : <Navigate to="/login" replace state={{ from: location }} />}>
        <Route path="/" element={<Dashboard />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/survey/:accessId" element={<SurveyFlow />} />
        <Route path="/survey/:accessId/result" element={<Result />} />
        {user?.role === 'admin' && <Route path="/admin/zugaenge" element={<AdminZugaenge />} />}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  )
}
